import { HealthCardType } from "../../dtos/KioskDtos.dtos";
import { IHealthCardParser } from "./BaseHealthCardParser";
import { BritishColumbiaCardParser } from "./BritishColumbiaCardParser";
import { MexicoCardParser } from "./MexicoCardParser";
import { NewBrunswickHealdCardNumberParser } from "./NewBrunswickHealthCardParser";
import { OntarioHealdCardNumberParser } from "./OntarioHealthCardParser";
import { QuebecCardParser } from "./QuebecHealthCardScanParser";

export class HealthCardParserSelector {
    public static GetParser(type: HealthCardType): IHealthCardParser | null {
        return this.Parsers[type] ? this.Parsers[type] : null;
    }

    private static Parsers: {[index: number]: IHealthCardParser } = {
        [HealthCardType.CA_BC_MSP]: new BritishColumbiaCardParser(),
        [HealthCardType.CA_NB_MEDICARE]: new NewBrunswickHealdCardNumberParser(),
        [HealthCardType.CA_ON_OHIP]: new OntarioHealdCardNumberParser(),
        [HealthCardType.CA_QC_RAMQ]: new QuebecCardParser(),
        [HealthCardType.MX_ALL_CURP]: new MexicoCardParser()
    };
}


// WEBPACK FOOTER //
// ./src/services/HealthCardBarcodeScanParsers/HealthCardParserSelector.ts